import React, {FC} from "react";
import {makeStyles} from "@material-ui/core";
import {useTolgee} from "@tolgee/react";
import {Theme} from "@evennt-tech/api-v2-core";
import {
  useCurrentShowId,
  useEffectiveShowLanguages,
  useLanguageSelection,
} from "hooks";
import useBranding from "store/branding/branding.store";
import LanguagePicker from "./index";

const ShowLanguagePicker: FC<{className?: string}> = ({className}) => {
  const classes = useStyles();
  const tolgee = useTolgee(["language"]);
  const showId = useCurrentShowId();
  const {effective} = useEffectiveShowLanguages(showId);
  const onSelect = useLanguageSelection();
  const {getBranding} = useBranding();

  const isDark = getBranding(showId)?.theme === Theme.DARK;

  if (effective.length <= 1) {
    return null;
  }

  return (
    <LanguagePicker
      languages={effective}
      currentCode={tolgee.getLanguage()}
      onSelect={onSelect}
      id="show-language-picker"
      isDark={isDark}
      className={className || (isDark ? classes.darkBackground : undefined)}
    />
  );
};

const useStyles = makeStyles(() => ({
  darkBackground: {
    backgroundColor: "#00000033",
    "&:hover": {
      backgroundColor: "#00000033",
    },
  },
}));

export default ShowLanguagePicker;
